import React from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import DeleteUserTable from "../../../components/table/all-tables/usermanagementtable/DeleteUserTable";
import { userManage } from "../../../locales/en";

const DeleteUser = () => {
  return (
    <>
      <TablePagesTitle
        mainTitle={userManage?.mainTitle}
        content={userManage?.content}
      />
      <AccessPageAction
        subheading={userManage?.deleteUser}
        alluser="/admin/access/user"
        allUserTitle={userManage?.activeUser}
        createuser="/admin/access/user/create"
        createUserTitle={userManage?.creteUser}
        deactivate="/admin/access/user/deactivated"
        deactivateTitle={userManage?.deactiveUserBtn}
        deleteuser="/admin/access/user/deleted"
        deleteUserTitle={userManage?.deleteUser}
      />
      <div className="row mb-3 mx-0">
        <div className="col-12">
          <DeleteUserTable />
        </div>
      </div>
    </>
  );
};

export default DeleteUser;
